import { View } from 'react-native';
export default View;
//# sourceMappingURL=ScreenStack.web.js.map